import ApiService from '@/services/api.service'

const ChargeSheet = {

    getAll(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/",       
               params: {
                 SearchCriteria: parameter.SearchCriteria,
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,  
                 DateFrom: parameter.DateFrom,
                 DateTo: parameter.DateTo,
                 Status: parameter.Status,
                 ProgramCode: parameter.ProgramCode
               }
             }       
             return ApiService.customRequest(requestData);
       }, 
}

export default ChargeSheet;